import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateShiftRequest {
    bookingRoleId: string;
    startAt: Date;
    endAt: Date;
    quantity: number;
    break: number;
    isPaidBreak: boolean;
}